import React from "react";
import DrawerRemoveObjectComponent from "./DrawerRemoveObjectComponent";
import DrawerGoBackComponent from "./DrawerGoBackComponent";
import { CurrentDrawerOpenType } from "state/slices/RightDrawerSlice";
import CMRSliderComponent, { SliderType } from "./CMRSliderComponent";
import BSUPatientHeader from "./BSUPatientHeader";

const DrawerSlaveComponent = (): JSX.Element => {
    return (
        <>
            <BSUPatientHeader title={"Slave Stack"} />
            <CMRSliderComponent type={SliderType.Slave} title={"Rotate"} />
            <DrawerRemoveObjectComponent
                classes={"mt-35 onlyDesktop"}
                type={"slave"}
                payload={"Slave"}
            />
            <DrawerGoBackComponent classes="onlyDesktop" type={CurrentDrawerOpenType.Surgeon} />
        </>
    );
};

export default DrawerSlaveComponent;
